import { ArrowUpRight } from 'lucide-react';
import React from 'react';

import { StatusBadge } from '~/components/Table';

export const PendingApprovalStatus: React.FC = () => (
  <StatusBadge tone="warning" className="gap-0">
    Pending approval
    <span className="grid grid-cols-[0fr] transition-[grid-template-columns] duration-200 ease-out group-hover/row:grid-cols-[1fr]">
      <span className="flex overflow-hidden">
        <ArrowUpRight className="ml-1 size-3.5 shrink-0 -translate-x-1 opacity-0 transition duration-200 ease-out group-hover/row:translate-x-0 group-hover/row:opacity-100" />
      </span>
    </span>
  </StatusBadge>
);
